import { render, staticRenderFns } from "./AscPlotFooterWrapper.vue?vue&type=template&id=514a6590&"
import script from "./AscPlotFooterWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotFooterWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports